import { Card, CardBody, Col, Table } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { RecentTradingActivitiesHeading } from "../../../../utils/Constant";
import RecentTradingActivitiesHeader from "./RecentTradingActivitiesHeader";
import RecentTradingActivitiesBody from "./RecentTradingActivitiesBody";

const RecentTradingActivities = () => {
  return (
    <Col xl="6" className="proorder-xl-6 proorder-lg-7">
      <Card className="recent-activities">
        <CardHeaderCommon title={RecentTradingActivitiesHeading} />
        <CardBody className="pt-0">
          <div className="custom-scrollbar">
            <Table responsive className="display w-100" id="recent-trading" >
              <RecentTradingActivitiesHeader />
              <RecentTradingActivitiesBody />
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RecentTradingActivities;
